var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SaLinkOrHref',{staticClass:"cursor-pointer link",attrs:{"is-to":_vm.isTo,"url":_vm.url,"no-tab":!_vm.tab},on:{"click":_vm.navigate}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }